const getIsoWeekNumber = (d) => {
  if (!d) d = new Date();
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  const year = d.getUTCFullYear();
  const weekNumber = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  const weekString = `${weekNumber < 10 ? '0' : ''}${weekNumber}`;
  const fullWeekString = `${year}-W${weekString}`;

  return { year, weekString, fullWeekString, weekNumber };
}

const getIsoWeek = (weekNumber, year) => {
  if (!weekNumber && !year) {
    const currentWeek = getIsoWeekNumber();
    weekNumber = currentWeek.weekNumber;
    year = currentWeek.year;
  }

  // ISO 8601: Week 1 is the week with the first Thursday of the year
  // First, find the first Thursday of the year
  const firstDayOfYear = new Date(Date.UTC(year, 0, 1));
  const dayOfWeek = firstDayOfYear.getUTCDay() || 7; // Convert Sunday from 0 to 7

  // Calculate days to first Thursday (4 is Thursday in ISO)
  const daysToFirstThursday = (4 - dayOfWeek + 7) % 7;

  // Find the first Thursday
  const firstThursday = new Date(Date.UTC(year, 0, 1 + daysToFirstThursday));

  // The Monday of week 1 is 3 days before the first Thursday
  const firstMondayOfWeek1 = new Date(firstThursday);
  firstMondayOfWeek1.setUTCDate(firstThursday.getUTCDate() - 3);

  // Calculate the start date (Monday) of the requested week
  const startDate = new Date(firstMondayOfWeek1);
  startDate.setUTCDate(firstMondayOfWeek1.getUTCDate() + (weekNumber - 1) * 7);

  // Calculate the end date (Sunday) of the requested week
  const endDate = new Date(startDate);
  endDate.setUTCDate(startDate.getUTCDate() + 6);

  return { startDate, endDate };
}

const getIsoQuarterNumber = (d) => {
  if (!d) d = new Date();
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth();
  const quarter = Math.floor(month / 3) + 1;
  return { year, quarter };
}

const getIsoQuarter = (quarterNumber, year) => {
  if (!quarterNumber && !year) {
    const currentQuarter = getIsoQuarterNumber();
    quarterNumber = currentQuarter.quarterNumber;
    year = currentQuarter.year;
  }

  // ISO quarters are based on ISO weeks, not calendar months
  // Each ISO quarter contains exactly 13 ISO weeks

  // Calculate the starting week number for the requested quarter
  const startWeekNumber = 1 + (quarterNumber - 1) * 13;

  // Calculate the ending week number (start + 12 to include 13 weeks total)
  const endWeekNumber = startWeekNumber + 12;

  // Get the start and end dates using the ISO week functions
  const { startDate } = getIsoWeek(startWeekNumber, year);
  const { endDate } = getIsoWeek(endWeekNumber, year);

  return { startDate, endDate };
}

const getIsoMonth = (d) => {
  if (!d) d = new Date();
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1; // Adding 1 because getUTCMonth() returns 0-11
  const monthString = `${month < 10 ? '0' : ''}${month}`;
  const fullMonthString = `${year}-${monthString}`;
  return { year, month, monthString, fullMonthString };
}

export { getIsoWeekNumber, getIsoWeek, getIsoQuarter, getIsoMonth };